module.exports = __webpack_public_path__ + "static/img/quanqiugou.27d1df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quanqiugou.png
// module id = 2+0y
// module chunks = 19